import CoBrand from "../../molecules/CoBrand/CoBrand";
import "./Navbar.css";
 
const Navbar = ({ onRequestAccess }) => (
  <nav>
    <div className="wrap">
      <CoBrand />
      <div className="navlinks">
        <a href="#precision">Prévisions</a>
        <a href="#vigilance">Vigilance</a>
        <a href="#particuliers">Particuliers</a>
        <a href="#professionnels">Professionnels</a>
        <a href="#notifications">Notifications</a>
        <a href="#apropos">À propos</a>
      </div>
      <span className="navbar-brand-text">ensemblepourlaforet.fr</span>
    </div>
  </nav>
);
 
export default Navbar;